import React, { Component } from 'react'
import { Route, Switch } from 'react-router'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'react-router-redux'

import App from './App'
import Login from './Login'
import Recovery from './Recovery'
import Forgot from './Forgot'
import CreateAccount from './CreateAccount'
import CreateOrganizationUser from './CreateOrganizationUser'
import CreateOrganization from './CreateOrganization'
import Terms from './Terms'
import ARTerms from './ARTerms'
import Privacy from './Privacy'
import { PrivateRoute } from '../components';
import { history, store } from '../store'
import { logout } from '../actions/auth-actions';
import { push } from '../actions/nav-actions';
import { fetchLocalData } from '../actions/auth-actions'


class Routes extends Component {
    componentWillMount() {
        store.dispatch(fetchLocalData());
    }
    render() {
        return (
            <Provider store={store}>
                <ConnectedRouter history={history}>
                    <Switch>
                        <Route path="/login" component={Login} />
                        <Route path="/logout" component={() => {
                            store.dispatch([logout(), push('/')])
                            return null;
                        }} />
                        <Route path="/forgot" component={Forgot} />
                        <Route path="/recovery" component={Recovery} />
                        <Route path="/create-account" exact component={CreateAccount} />
                        <Route path="/create-account/:code" component={CreateOrganizationUser} />
                        <Route path="/create-organization" component={CreateOrganization} />
                        <Route path="/terms" component={Terms} />
                        <Route path="/ar-terms" component={ARTerms} />
                        <Route path="/privacy" component={Privacy} />
                        <PrivateRoute path="/" component={App} />
                    </Switch>
                </ConnectedRouter>
            </Provider>
        );
    }
}

export default Routes; 


// WEBPACK FOOTER //
// ./src/routers/index.js